import React from 'react';
import {Modal} from "@tag/tag-components-react-v4";
import {CustomerDTO} from "../types/CustomerDTO";
import AppRolesService from "../../General/services/AppRolesService";
import {useIsAuthenticated, useMsal} from "@azure/msal-react";


function DeleteConfirmationModal(props: { visible: boolean, selectedCustomer: CustomerDTO, handleClose: Function, handleDelete: Function }) {
    
    const { accounts } = useMsal();
    const isAuthenticated = useIsAuthenticated();

    if (!AppRolesService.canUserDeleteEnvironments(accounts, isAuthenticated)) {
        throw new Error()
    }

    const renderModalContent = () => {
        let modalContent;
        

        modalContent = (
            <>
                Are you sure you wish to delete {props.selectedCustomer.name}?
            </>
        )

        return modalContent;
    }

    let content;
    content = <>
        <Modal
            visible={props.visible}
            accent='teal'
            heading={'Confirm'}
            onCancelButtonClick={() => {
                props.handleClose();
            }}
            onClose={() => props.handleClose()}
            primaryButtonProps={{text: 'Confirm'}}
            onPrimaryButtonClick={() => props.handleDelete()}
        >
            <div>
                {renderModalContent()}
            </div>
        </Modal>
    </>

    return (
        <>
            {content}
        </>
    )

}

export default DeleteConfirmationModal;
